import type { WritableComputedRef } from 'vue'
import { confirm } from '@/common/utils/confirm'
import type { ISPPlanDetail, ISPPlanType } from '@/api/rxjs/knst/ISPForm/models/get_plans.model'

export class SelectedPlan {
  planType: ISPPlanType | null
  planDetail: ISPPlanDetail | null
  addonItems: Record<number, number> = {}
  addonItems_ref: Record<number, WritableComputedRef<number>> = {}
  private addonDebounceTimeouts: Record<number, ReturnType<typeof setTimeout>|undefined> = {}

  constructor() {
    this.planType = null
    this.planDetail = null
  }
  reset() {
    this.planType = null
    this.planDetail = null
    this.resetAddons()
  }

  /**
   * 只清加購品項，保留已選方案。
   * 諮詢流程用：方案是 step0 選定的「預約專人來電說明」，各方案類型各有一張且 id 不同
   * （家用網路／家用網路+手機門號 是獨立方案，只是行為相同），必須一路保留到 apptInfo 送單。
   * 若在此被清成 null，apptInfo 會退回 getContactPlanIds() 取「第一個類型」的那張，
   * 使「家用網路+手機門號」的諮詢單被誤記成「家用網路」。
   */
  resetAddons() {
    Object.keys(this.addonItems).forEach(key => {
      this.addonItems[+key] = 0
    })
  }

  setAddonSetterGetter(id: number) {
    this.addonItems[id] = 0
    this.addonItems_ref[id] = computed<number>({
      get: () => this.addonItems[id] ?? 0,
      set: (newValue) => {
        if (newValue > 0) {
          this.addonItems[id] = newValue
          return
        }
        // 避免按鍵刪除導致跳出多個視窗
        if (this.addonDebounceTimeouts[id]) return

        this.addonDebounceTimeouts[id] = setTimeout(() => {
          confirm({
            message: '確定要移除當前品項嗎？',
            title: '系統提示'
          }).subscribe(res => {
            if (res === 'confirm') this.addonItems[id] = 0

            this.addonDebounceTimeouts[id] = undefined
          })
        })
      }
    })
  }

  clearAddonItem(id: number) {
    confirm({
      message: '確定要移除當前品項嗎？',
      title: '系統提示'
    }).subscribe(
      res => {
        (res === 'confirm') && (this.addonItems[id] = 0)
      }
    )
  }

}